/**
 * @overview 话题查看
 * @author jzhu
 * @date 2020-9-11
 */

import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool, utils_tool } from '@/tool'

let { WizContainer, ossFileUtils, modelUtils } = framework_tool
let { WizCard, WizDescriptions, WizSpin } = component_tool
let { Session } = utils_tool
import { WizAuthority } from '../../../common'

const getParamRecord = (history) => {
  let record = {}
  if (history.location) {
    if (history.location.record) {
      if (history.location.pathname === '/community/topic/topicLook'
        || history.location.pathname === '/featured/management/featuredLook/featuredTopic') {
        record.id = history.location.record.id
      } else if (history.location.pathname === '/interact/activity/activityTopic/topicLook') {
        record.id = history.location.record.topicId
      }
      Session.set('topicLook', record)
    } else {
      record = Session.get('topicLook') || {}
    }
  }
  return record
}

class TopicLook extends WizContainer {

  componentName = 'TopicLook'

  constructor(props) {
    super(props)
    let { history } = props
    let record = getParamRecord(history)
    this.state = {
      record
    }
  }

  _componentDidMount() {
    let { record } = this.state
    if (record && record.id) {
      this.doAction({
        path: 'topic/look',
        payload: {
          key: 'topicInfo',
          apiParams: { id: record.id }
        }
      })
    }
  }

  propsAndStateOnChange = {
    topicInfo: this._topicInfoOver.bind(this)
  }

  _topicInfoOver(nextProps, nextState) {
    let { topicInfo } = nextProps
    if (topicInfo.code == 1) {
      if (topicInfo && topicInfo.success) {
        nextState.record = topicInfo.data
      }
    } else {
      wizNotice.error(nextProps.topicInfo.msg);
    }
    return true;
  }

  _columns = () => {
    return [
      {
        title: '话题名称',
        name: 'title',
        dataIndex: 'title',
        describeItem: {}
      },
      {
        title: '话题简介',
        name: 'introduce',
        dataIndex: 'introduce',
        describeItem: {}
      },
      {
        title: '头像',
        name: 'icon',
        dataIndex: 'icon',
        describeItem: {
          render: (text, record) => {
            let { icon} = record
            return <img height={100} width={100}  src={getOssFilePath(icon)} />
          }
        }
      },
      {
        title: '背景',
        name: 'img',
        dataIndex: 'img',
        describeItem: {
          render: (text, record) => {
            let { img} = record
            return <img height={100} width={250}  src={getOssFilePath(img)} />
          }
        }
      },
      {
        title: '受众',
        name: 'authInfo',
        dataIndex: 'authInfo',
        describeItem: {
          render: (text, record) => {
            let wizAuthorityProps = {
              keys: ['orgIds', 'positionIds', 'positionCategoryIds', 'personIds'],
              value: record.authInfo,
              showBlock: false,
              mode: 'Show'
            }
            return <WizAuthority {...wizAuthorityProps} />
          }
        }
      },
      {
        title: '有效日期',
        name: 'date',
        dataIndex: 'date',
        describeItem: {
          render: (text, record) => {
            let { start, end } = record
            let value = start + ' ~ ' + end
            return <div>{value}</div>
          }
        }
      },
      {
        title: '话题状态',
        name: 'state',
        dataIndex: 'state',
        dict: [
          { code: 1, codeName: '有效' },
          { code: 0, codeName: '无效' }
        ],
        describeItem: {}
      },
      {
        title: '创建时间',
        name: 'createTime',
        dataIndex: 'createTime',
        describeItem: {}
      },
    ]
  }

  _render() {
    let { record } = this.state
    let wizDescriptionsProps = {
      record,
      columns: this._columns(),
      column: 1,
      bordered: true
    }
    return (
      <WizCard>
        <WizSpin tip={'加载中'} spinning={this.props.topicLoading}>
          <WizDescriptions {...wizDescriptionsProps} />
        </WizSpin>
      </WizCard>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { topic } = state;
  const topicInfo = modelUtils.getModelEntity(topic, 'topicInfo');
  const load = modelUtils.getLoadingState(state, 'topic')
  return {
    topicInfo,
    ...load
  }
}

export default connect(mapStateToProps)(TopicLook)
